import React from "react";
import HeaderWithSearch from "./HeaderWithSearch";
import ImageWithFallback from "./ImageWithFallback";

function VanillaMilkshake() {
  return (
    <>
      <HeaderWithSearch />
      <main
        style={{
          minHeight: "100vh",
          width: "100%",
          background: "linear-gradient(180deg, #e3f0fc 0%, #fafdff 100%)",
          padding: 0,
          margin: 0,
        }}
      >
        <section
          className="recipe-hero-anim"
          style={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
            minHeight: "60vh",
            padding: "60px 20px 40px 20px",
          }}
        >
          <h1
            className="recipe-title-anim"
            style={{
              fontSize: "3rem",
              fontWeight: "bold",
              marginBottom: 16,
              textAlign: "center",
            }}
          >
            Vanilla Milkshake
          </h1>
          <span className="season-badge season-summer" style={{ marginBottom: 24 }}>☀️ Best in Summer</span>
          <ImageWithFallback
            src="/vanilla_milkshake.jpg"
            alt="Vanilla Milkshake"
            className="recipe-image-anim"
            style={{
              width: 400,
              height: 300,
              objectFit: "cover",
              borderRadius: 24,
              boxShadow: "0 4px 32px rgba(0,0,0,0.10)",
              marginBottom: 32,
            }}
          />
          <div
            style={{
              maxWidth: 800,
              fontSize: "1.1rem",
              color: "#333",
              lineHeight: 1.8,
            }}
          >
            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Ingredients:
            </h2>
            <ul className="ingredient-list" style={{ marginBottom: 24, paddingLeft: 20 }}>
              <li>2 cups vanilla ice cream</li>
              <li>1 cup cold milk</li>
              <li>1 tsp vanilla extract</li>
              <li>2 tbsp sugar (adjust to taste)</li>
              <li>Whipped cream for topping (optional)</li>
              <li>Chocolate syrup for drizzle (optional)</li>
              <li>Sprinkles or chocolate shavings for garnish (optional)</li>
              <li>Maraschino cherry for garnish (optional)</li>
            </ul>

            <h2 style={{ fontSize: "1.5rem", fontWeight: 600, marginBottom: 16 }}>
              Instructions:
            </h2>
            <ol className="instructions-list" style={{ paddingLeft: 20 }}>
              <li style={{ marginBottom: 12 }}>
                <strong>Chill glasses:</strong> Place your serving glasses in the freezer for 10-15 minutes before making the milkshake for an extra cold treat.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Blend ingredients:</strong> In a blender, add the vanilla ice cream, cold milk, vanilla extract, and sugar.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Blend until smooth:</strong> Blend on medium-high speed for 30-60 seconds until the mixture is smooth and creamy. If too thick, add a splash more milk. If too thin, add more ice cream.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Check consistency:</strong> The milkshake should be thick enough to coat the back of a spoon but still drinkable through a straw.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Pour into glasses:</strong> Remove glasses from freezer and pour the milkshake immediately.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Add toppings:</strong> Top with whipped cream, drizzle with chocolate syrup, and add sprinkles or a cherry if desired.
              </li>
              <li style={{ marginBottom: 12 }}>
                <strong>Serve immediately:</strong> Serve with a thick straw and a long spoon. Enjoy right away while cold!
              </li>
            </ol>

            <div
              className="chef-tips-box"
              style={{
                background: "#f8f9fa",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="chef">👨‍🍳</span> Chef's Tips:
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Use good quality vanilla ice cream for the best flavor</li>
                <li>For a richer shake, use whole milk or add heavy cream</li>
                <li>Add a pinch of salt to enhance the vanilla flavor</li>
                <li>Try adding crushed Oreos or cookies for a cookies & cream variation</li>
                <li>For a healthier version, use frozen bananas instead of some ice cream</li>
                <li>Blend in malt powder for a classic malted milkshake</li>
              </ul>
            </div>

            <div
              className="health-benefits-box"
              style={{
                background: "#eef9f0",
                padding: 20,
                borderRadius: 12,
                marginTop: 24,
              }}
            >
              <h3 style={{ fontSize: "1.3rem", fontWeight: 600, marginBottom: 12 }}>
                <span className="tip-icon" role="img" aria-label="health">🌿</span> Health Benefits
              </h3>
              <ul style={{ paddingLeft: 20 }}>
                <li>Milk and ice cream supply calcium and protein that support bones and muscles.</li>
                <li>A satisfying treat that can help curb sugar cravings in one indulgent serving.</li>
                <li>Blending in a frozen banana adds potassium and fiber while cutting some of the sugar.</li>
                <li>Best enjoyed in moderation as part of a balanced diet, like any dessert.</li>
              </ul>
            </div>
          </div>
        </section>
      </main>
    </>
  );
}

export default VanillaMilkshake;